/**
 * MentorsSection — four mentor cards. Real headshots + bios wired in
 * Feb 2026 (Tadhg, Anusha, Chinara, Axel — order locked by the owner).
 * Each card uses a 4:5 portrait crop so the photos read at any width.
 */
import SectionHeading from './SectionHeading';
import CarouselGrid from './CarouselGrid';

const MENTORS = [
  {
    name: 'Tadhg Ingel-Jones',
    photo: 'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782400407/_28A5927_1_izarqe.jpg',
    bio: "A disciplinary studies major, now in his third year teaching with us. He's deeply invested in his community, using tech education to open doors for the young people growing up in it.",
  },
  {
    name: 'Anusha Raghavendiran',
    photo: 'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782400719/_28A4201_1_sylomu.jpg',
    bio: "A few summers ago she was the camper raising her hand. That's exactly why campers listen to her.",
  },
  {
    name: 'Chinara Caldwell',
    photo: 'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782401021/PXL_20260608_144036616_ed7i2i.jpg',
    bio: "IMSA alumni who's a computer science major, endlessly patient with first-time coders.",
  },
  {
    name: 'Axel Aguilar',
    photo: 'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782400820/PXL_20230307_003642264.PORTRAIT_ur5lig.jpg',
    bio: 'IMSA student who started in these same classes as a learner. Now he runs the room!',
  },
];

export default function MentorsSection() {
  return (
    <section
      id="mentors"
      className="bg-rsc-slate-soft py-16 sm:py-20 font-poppins scroll-mt-32"
      data-testid="mentors-section"
    >
      <div className="container-app">
        <SectionHeading
          eyebrow="Who they'll learn from"
          title="Mentors,"
          accent="not just instructors."
          body="Camps are led by student mentors: near-peer role models who are genuinely into STEM and know how to make it click for a child. They keep groups small, hands-on, and curious."
        />

        <div className="mt-10 max-w-6xl mx-auto">
          <CarouselGrid variant="fourCol" data-testid="mentors-grid">
            {MENTORS.map((m, i) => (
              <article
                key={m.name}
                className="h-full rounded-2xl bg-white border border-rsc-card-border overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
                data-testid={`mentor-card-${i}`}
              >
                <div className="aspect-[4/5] bg-rsc-slate-soft overflow-hidden">
                  <img
                    src={m.photo}
                    alt={`${m.name} — Ready Set STEM instructor`}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <h4 className="text-sm sm:text-base font-extrabold text-rsc-brand-blue leading-tight">
                    {m.name}
                  </h4>
                  <p className="mt-1.5 text-[12px] sm:text-[13px] text-rsc-charcoal leading-snug">
                    {m.bio}
                  </p>
                </div>
              </article>
            ))}
          </CarouselGrid>
        </div>
      </div>
    </section>
  );
}
